import { render, staticRenderFns } from "./WorkspaceExpandHistoryPanel.vue?vue&type=template&id=44a2647c&scoped=true"
import script from "./WorkspaceExpandHistoryPanel.vue?vue&type=script&lang=js"
export * from "./WorkspaceExpandHistoryPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExpandHistoryPanel.vue?vue&type=style&index=0&id=44a2647c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a2647c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a2647c')) {
      api.createRecord('44a2647c', component.options)
    } else {
      api.reload('44a2647c', component.options)
    }
    module.hot.accept("./WorkspaceExpandHistoryPanel.vue?vue&type=template&id=44a2647c&scoped=true", function () {
      api.rerender('44a2647c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExpandHistoryPanel.vue"
export default component.exports